module.exports = {
  createEncoder: (FbLib, fbBuilder) => {
    return function(entity, method, ...values) {
      return FbLib[entity][method](fbBuilder, ...values)
    }
  },

  createStringEncoder: (fbBuilder, map) => {
    return function(str) {
      if (!str) {
        return
      }

      if (!map.has(str)) {
        map.set(str, fbBuilder.createString(str))
      }

      return map.get(str)
    }
  },

  createEnumEncoder: (FbLib) => {
    return function(name, value) {
      return FbLib[name][value]
    }
  },
}